import { yupResolver } from '@hookform/resolvers/yup'
import { Button, FormLayout, TextInput } from 'components/common'
import StoreDropdown from 'components/userManagement/storeDropdown'
import { useState } from 'react'
import { useForm } from 'react-hook-form'
import { getStockInventory } from 'utils/api/inventoryApi'
import * as yup from 'yup'

const stockCheckerSchema = yup.object({
  catalogue: yup.string().required('Catalogue is required'),

  store: yup.string().required('Store is required'),
})

const StockChecker = () => {
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(stockCheckerSchema),
  })

  const [erpQty, setErpQty] = useState<number | null>(null)
  const [message, setMessage] = useState<string>('')

  const onSubmit = async (data: any) => {
    setErpQty(null)
    setMessage('')

    const { data: res } = await getStockInventory({ filters: data })

    if (!res || res.length === 0) {
      setMessage('No stock found for the selected catalogue and store')
      return
    }

    setErpQty(res[0].erpQty)
  }

  return (
    <>
      <div className="mb-4">
        <h3 className="title">Stock Checker</h3>
      </div>

      <FormLayout>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="grid grid-cols-3 items-start gap-6">
            <div className="flex flex-col">
              <TextInput
                label="Catalogue"
                name="catalogue"
                register={register}
                required
                error={errors.catalogue?.message}
              />
              <div className="min-h-[18px]" />
            </div>

            <div className="flex flex-col">
              <StoreDropdown
                required
                label="Store"
                setValue={setValue}
                name="store"
                error={errors.store?.message}
              />
              <div className="min-h-[18px]" />
            </div>
          </div>
          <div className="flex h-full items-center justify-start ">
            <Button type="submit" buttonText="Search" className="h-[42px]" />
          </div>
        </form>
      </FormLayout>

      <div className="mt-4">
        {erpQty !== null && (
          <h3 className="font-semibold text-green-700">
            Available Stock: {erpQty}
          </h3>
        )}

        {message && <h3 className="font-semibold text-red-600">{message}</h3>}
      </div>
    </>
  )
}

export default StockChecker
